<template>
  <Router-view></Router-view>
</template>
<script>

import Header from '@/components/Header/Header.vue'
export default {
  components: {
    Header
  }
}
</script>
<style>
  
</style>